import React from 'react';
import WelcomeFamphyClinics from './WelcomeFamphyClinics';
import { Link } from 'react-router-dom';

export default function ClinicVisitBhartiyaCity() {
  return (
    <>
      <div className='Inner-banner'>
        <img
          className="img-fluid"
          src={`${process.env.PUBLIC_URL}/img/famphy-clinic-banner2.jpg`}
          alt="FamPhy Clinic"
        />
      </div>

      <div className='clinic-visit'>

        <WelcomeFamphyClinics />

        {/* Clinic Information */}

        <div className='services-item container'>
          <div className='row'>

            <div className='col-lg-6 col-md-6 col-sm-12 v-align-middle mob-order-2 p-0'>
              <div className='services-item-content'>
                <h2>
                  Fam<span>Phy</span> Clinic
                </h2>

                <h4>
                  Lower Ground Floor, Mall of Bengaluru,
                  Bhartiya City, Bengaluru, 560064, Karnataka
                </h4>

                <Link
                  to="/contacts"
                  className="btn theam-btn-m"
                >
                  Contact Us
                </Link>
              </div>
            </div>

            <div className='col-lg-6 col-md-6 col-sm-12 mob-order-1 p-0'>
              <img
                className="img-fluid"
                src={`${process.env.PUBLIC_URL}/img/famphy-clinic-img01.jpg`}
                alt="FamPhy Clinic"
              />
            </div>

          </div>
        </div>

        {/* Doctor Profile Section */}

        <section className="doctor-profile-section">
          <div className="container">

            <div className="doctor-profile-card">

              <div className="row align-items-center">

                <div className="col-lg-4 col-md-4 text-center">
                  <img
                    src={`${process.env.PUBLIC_URL}/img/dr-darshitha-basappa.jpg`}
                    alt="Dr Darshitha Basappa"
                    className="doctor-profile-image"
                  />
                </div>

                <div className="col-lg-8 col-md-8">

                  <h2 className="doctor-name">
                    Dr. Darshitha Basappa
                  </h2>

                  <h5 className="doctor-speciality">
                    Specialist – Radiology
                  </h5>

                  <div className="doctor-qualification">
                    <span>MD Radiodiagnosis</span>
                    <span>DNB Radiodiagnosis</span>
                  </div>

                  <p>
                    Dr. Darshitha Basappa is an experienced Radiologist
                    with expertise in Ultrasound, X-Ray, CT Scan, MRI,
                    Mammography, Fluoroscopy and Cross-Sectional Imaging.
                  </p>

                  <p>
                    She completed her MBBS from MVJ Medical College and
                    Research Hospital, Bangalore and pursued MD
                    Radiodiagnosis from Vydehi Institute of Medical Sciences.
                    She further strengthened her expertise by earning
                    DNB Radiodiagnosis.
                  </p>

                  <p>
                    Her clinical interests include abdominal imaging,
                    neuroimaging and musculoskeletal radiology. She is
                    committed to providing accurate diagnosis and
                    patient-centred care through advanced imaging
                    techniques.
                  </p>

                  <div className="doctor-info-grid">

                    <div className="doctor-info-box">
                      <h6>Ultrasound Timings</h6>
                      <p>11:30 AM – 12:30 PM</p>
                    </div>

                    <div className="doctor-info-box">
                      <h6>Languages</h6>
                      <p>
                        Kannada, English, Telugu,
                        Tamil & Hindi
                      </p>
                    </div>

                  </div>

                  <Link
                    to="/contacts"
                    className="btn theam-btn-m mt-3"
                  >
                    Book Appointment
                  </Link>

                </div>

              </div>

            </div>

          </div>
        </section>

      </div>
    </>
  );
}